import type { IPagination } from '@/interfaces'
import { ListFilterTypeExpression } from '@/enum/LinqExpressionType'
import { DEFAULT_PAGE_LIMIT } from '@/utils/constants'
import { containsAllValues } from '@/utils/helpers'

export default {
  size(state: IPagination): number {
    return state?.data?.length || 0
  },
  hasMoreData(state: IPagination): boolean {
    return (
      state.currentPageSize > 0 &&
      state.offset > 0 &&
      ((state?.data?.length || 0) < state.totalRowCount || state.totalRowCount === -1)
    )
  },
  someItemsSelected(state: IPagination): boolean {
    if (state.selectedItems) {
      return (
        !this.allItemsSelected &&
        state?.data?.some(
          (item) =>
            state.selectedItems?.includes(item?.id) || state.selectedItems?.includes(item?.userName)
        )
      )
    }
    return false
  },
  allItemsSelected(state: IPagination): boolean {
    if (state?.data) {
      return state?.data?.every(
        (item) =>
          state.selectedItems?.includes(item?.id) || state.selectedItems?.includes(item?.userName)
      )
    }
    return false
  },
  showSnackbar(state: IPagination): boolean {
    return !!state.selectedItems?.length
  },
  showFailedSnackbar(state: IPagination): boolean {
    return !!(state.failed && state?.data?.length)
  },
  hasActiveFilters(state: IPagination): boolean {
    return Object.values(state.filtersOptions).length > 0
  },
  hasActiveFilterExpressionOptions(state: IPagination) {
    if (!state.filtersOptions?.[ListFilterTypeExpression.Filter]) return false
    return Object.values(state.filtersOptions?.[ListFilterTypeExpression.Filter]).some(
      (filter) =>
        filter !== undefined &&
        filter !== null &&
        ((Array.isArray(filter) && filter.length) ||
          (!Array.isArray(filter) && (!!filter || filter === 0) && containsAllValues(filter)))
    )
  },
  hasNoPagedData(state: IPagination): boolean {
    return state.totalRowCount > 0 && state.totalRowCount < DEFAULT_PAGE_LIMIT
  },
  activeFilterExpressionOptionsLength(state: IPagination) {
    if (!state.filtersOptions?.[ListFilterTypeExpression.Filter]) return 0
    return Object.keys(state.filtersOptions?.[ListFilterTypeExpression.Filter]).length
  },
  dropdownOptions(state: IPagination) {
    return state?.data?.map((item) => ({ value: item.id, title: item.title }))
  }
}
